import { Global } from "../Shared/Global";
import Constant from "../Shared/Constant";
import Utils from "../Shared/Utils";

const {ccclass, property} = cc._decorator;
const Duration = 3      // 控制进度条最快走完的时间
const MaxDuration = 8  // 控制进度条最慢走完时间

@ccclass
export default class LoadingUI extends cc.Component {
    @property(cc.ProgressBar)
    barLoading: cc.ProgressBar = null

    @property(cc.Label)
    lbProgress: cc.Label = null

    private _laodedScene = false
    private _totalTime = 0

    onLoad () {
        this.barLoading.progress = 0
        cc.director.on(Global.UserEvent.HallLoaded, this.onHallLoaded, this)
    }

    onDestroy () {
        cc.director.off(Global.UserEvent.HallLoaded, this.onHallLoaded, this)
    }

    update (dt) {
        this._totalTime += dt
        this.barLoading.progress = Math.min(1, this._totalTime / Duration)
        
        if (this._totalTime < MaxDuration && this.barLoading.progress === 1 && !this._laodedScene) {
            this.barLoading.progress = 0.9999
        }

        this.lbProgress.string = "游戏正在加载中... " + Math.floor(this.barLoading.progress * 100) + "%"

        if (this.barLoading.progress === 1) {
            this.enterHall()
        }
    }

    onBtnClick (event, userData) {
        if (userData === "kefu") {
            Utils.openOnlineCustomerUrl()
        }
    }

    onHallLoaded () {
        this._laodedScene = true
    }

    private enterHall () {
        cc.director.emit(Global.UserEvent.LoadingHallEnd)
        this.node.destroy()
        this.node.parent = null
    }
}
